module.exports = __webpack_public_path__ + "static/media/cinema-icon.349c164b.svg";